import { render, staticRenderFns } from "./ControlOrder.vue?vue&type=template&id=364cb2cc"
import script from "./ControlOrder.vue?vue&type=script&lang=js"
export * from "./ControlOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports